<template>
  <div class="section-h">
    <h1 class="is-size-3 is-uppercase is-underlined">Search Results for <span>'{{searchString}}'</span></h1>
    <div class="table-wrap" v-if="!isLoading">
      <table class="table table is-fullwidth is-striped push-top" v-for="(obj, idx) in searchResults" :key="idx">
        <tbody>
          <tr><td class="is-paddingless is-size-3 is-uppercase" colspan="3">{{obj.title}}</td></tr>
          <tr v-for="(honoree, idx) in obj.results" :key="idx">
            <router-link class="is-size-4 has-text-white" :to="{name:'honoree-detail', params:{honor:obj.slug,id:honoree.id}}">
              <td>{{honoree.first_name}}&nbsp;{{honoree.last_name}}</td>
              <td>{{honoree.year}}</td>
              <td><span v-for="(sport, idx) in honoree.sports" :key="sport.id">{{sport.name}}<span v-if="idx < honoree.sports.length - 1">, </span></span></td>
            </router-link>
          </tr>
        </tbody>
      </table>
    </div>
    <app-nav></app-nav>
  </div>
</template>

<script>
import Endpoints from '@/components/Endpoints.js';

export default {
  name: 'search-results',
  data() {
    return {
      searchString: this.$router.currentRoute.params.searchString,
      searchResults: [],
      endpoints: Endpoints.List
    };
  },
  computed: {
    isLoading() {
      return false; //temp
      //return this.$store.state.pending[this.endpoint.listProperty];
    }
  },
  mounted() {
    let params = {
      query: this.searchString
    };
    this.endpoints.forEach(e => {
      this.$store.dispatch(e.searchAction, { params }).then(res => {
        if (res.data.results.length) {
          this.searchResults.push({
            title: e.title,
            slug: e.slug,
            results: res.data.results
          });
          //this.searchResults.push([...res.data.results])
        }
      });
    });
    console.log(this.searchResults);
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/helpers.scss';

h1 span,
tbody > tr {
  color: $gold;
}
</style>

